import { useFormContext } from "../rhf"

export const useOnCheckboxChange = (fieldName: string): (text: string, include?: boolean) => void => {
  const {
    getValues,
    setValue,
  } = useFormContext()

  return (text: string, include?: boolean) => {
    const currentValueRaw = getValues(fieldName) as string | undefined
    const currentValue = currentValueRaw?.length ? currentValueRaw + ' ' : ''

    if (include && !currentValue.includes(text)) {
      setValue(fieldName, `${currentValue}${text}`.trim(), { shouldValidate: true })
    } else {
      setValue(
        fieldName,
        currentValue.replace(text, '').replace(/\s+/g, ' ').trim(),
        { shouldValidate: true }
      )
    }
  }
}

export const getMeetingRecordCheckboxValues = (
  texts: { [key: string]: string },
  fullText?: string
): [string, string, boolean][] => Object.keys(texts).map((key) => {
  const isChecked = !!fullText?.includes(texts[key].trim())
  return [key, texts[key].trim(), isChecked]
})
